import { render, staticRenderFns } from "./VoteScreen.vue?vue&type=template&id=2cefcfde&scoped=true"
import script from "./VoteScreen.vue?vue&type=script&lang=js"
export * from "./VoteScreen.vue?vue&type=script&lang=js"
import style0 from "./VoteScreen.vue?vue&type=style&index=0&id=2cefcfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefcfde",
  null
  
)

export default component.exports